import { Action } from '@ngrx/store';
import { FilterItemInterface } from 'app/site-filters/models';

import { SiteFilterActionType } from '.';

export class DeleteManagementSiteFilterItem implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.DeleteManagementSiteFilterItem;

  constructor(public readonly payload?: { filterId: number, filterItem: FilterItemInterface }) { }
}

export class DeleteManagementSiteFilterItemCompleted implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.DeleteManagementSiteFilterItemCompleted;

  constructor(public readonly payload?: { filterId: number, filterItem: FilterItemInterface }) { }
}

export class DeleteManagementSiteFilterItemFailed implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.DeleteManagementSiteFilterItemFailed;

  constructor(public readonly payload?: { filterId: number, filterItem: FilterItemInterface }) { }
}
